import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Card, TextareaAutosize } from "@mui/material";
import useWindowDimensions from "../../../CustomHooks/useWindowdimension";
import camera from "../../../../src/images/camera.png";
export default function ClusterEdit({
  individualopen,
  handleClose,
  baseUrl,
  forceUpdate,
  updateCluster,
  clusterName,
  setClusterName,
  clusterProfileImage, setClusterImage,
  clusterGuideLines, setClusterGuideLines,
  aboutCluster, setAboutCluster

}) {
  const { height, width } = useWindowDimensions();
  return (
    <div>
      <Dialog open={individualopen} onClose={handleClose}>
        <DialogTitle>Update your cluster profile</DialogTitle>
        <DialogContent>
          <Card
            style={{
              width: width > 768 ? "552px" : width > 450 ? "76vw" : "70vw",
            }}
            className="image-upload"
            sx={{ ml: 1, p: 1 }}
          >
            {clusterProfileImage ? (
              <label htmlFor="file-input">
                <img
                  src={URL.createObjectURL(clusterProfileImage)}
                  alt=""
                  className="rounded-full w-[100px] h-[100px] border-2 cursor-pointer"
                />
              </label>
            ) : (
              <label htmlFor="file-input">
                <img
                  src={camera}
                  alt=""
                  className="rounded-full w-[100px] h-[100px] border-2 cursor-pointer"
                />
              </label>
            )}
            <input
              id="file-input"
              type="file"
              onChange={(e) => setClusterImage(e.target.files[0])}
            />
            {/* <Typography>Upload Image</Typography> */}
          </Card>

          <span className="ml-5">Upload Image</span>
          <TextField
            fullWidth
            label="Enter Your Topic"
            placeholder="Keep it on academic or career related"
            variant="outlined"
            sx={{ m: 1 }}
            maxLength={10}
            onChange={(e) => setClusterName(e.target.value)}
            value={clusterName}
          />
          <TextField
            fullWidth
            label="Guidelines"
            placeholder="How do you want the members to interact"
            variant="outlined"
            sx={{ m: 1 }}
            onChange={(e) => setClusterGuideLines(e.target.value)}
            value={clusterGuideLines}
          />
          <TextareaAutosize
            autoFocus
            minRows={5}
            minLength={10}
            // maxLength={200}
            value={aboutCluster}
            onChange={(e) => setAboutCluster(e.target.value)}
            placeholder="Tell the objective to the members"
            style={{
              width: width > 768 ? "552px" : "100%",
              padding: "5px",
              border: "2px solid #EAE0DA",
              marginLeft: "8px",
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={updateCluster}>update</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
